module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_03-7bfac87259014a17db0684d3b76709e9.png";